import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/sparkle.svg'
import _imports_1 from '@/assets/icons/star.svg'
import _imports_2 from '@/assets/icons/document.svg'
import _imports_3 from '@/assets/icons/photo_sepia.svg'
import _imports_4 from '@/assets/icons/connected_tree_arm.svg'
import _imports_5 from '@/assets/icons/connected_tree_base.svg'
import _imports_6 from '@/assets/icons/person_gray_150.png'


const _withScopeId = n => (_pushScopeId("data-v-3de4ef96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page-value" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"value-row fun-value\" data-v-3de4ef96><div class=\"container-lg\" data-v-3de4ef96><h1 data-v-3de4ef96>Easy and fun to explore</h1><h4 data-v-3de4ef96>Make your tree into a personalized learning experience for each family member.</h4><div class=\"details\" data-v-3de4ef96><div class=\"visual\" data-v-3de4ef96><img src=\"" + _imports_0 + "\" data-v-3de4ef96><img src=\"" + _imports_0 + "\" data-v-3de4ef96><img src=\"" + _imports_1 + "\" data-v-3de4ef96><img src=\"" + _imports_1 + "\" data-v-3de4ef96><img src=\"" + _imports_1 + "\" data-v-3de4ef96></div><ul class=\"list-unstyled value-list\" data-v-3de4ef96><li data-v-3de4ef96>A relationship map helps them see how each person is related to them.</li><li data-v-3de4ef96>They can explore names and places important to their family.</li><li data-v-3de4ef96>We automatically highlight interesting facts we discovered in their tree.</li><li data-v-3de4ef96>Which ancestors have a twin? What was the population of great-grandma&#39;s hometown when she was born?</li></ul></div></div></div><div class=\"value-row content-value\" data-v-3de4ef96><div class=\"container-lg\" data-v-3de4ef96><h1 data-v-3de4ef96>Photos and documents</h1><h4 data-v-3de4ef96>It&#39;s easy to let your family explore your whole collection.</h4><div class=\"details\" data-v-3de4ef96><div class=\"visual\" data-v-3de4ef96><img src=\"" + _imports_2 + "\" class=\"doc\" data-v-3de4ef96><img src=\"" + _imports_3 + "\" class=\"photo\" data-v-3de4ef96><img src=\"" + _imports_2 + "\" class=\"doc\" data-v-3de4ef96><img src=\"" + _imports_3 + "\" class=\"photo\" data-v-3de4ef96><img src=\"" + _imports_3 + "\" class=\"photo\" data-v-3de4ef96><img src=\"" + _imports_3 + "\" class=\"photo\" data-v-3de4ef96></div><ul class=\"list-unstyled value-list\" data-v-3de4ef96><li data-v-3de4ef96>View original documents you&#39;ve collected about your ancestors.</li><li data-v-3de4ef96>Your linked photos and documents are all uploaded automatically.</li><li data-v-3de4ef96>Zoom in to see photos at their original quality.</li></ul></div></div></div><div class=\"value-row connected-value\" data-v-3de4ef96><div class=\"container-lg\" data-v-3de4ef96><h1 data-v-3de4ef96>Related trees are connected</h1><h4 data-v-3de4ef96>We automatically connect your tree to the trees for the rest of their family.</h4><div class=\"details\" data-v-3de4ef96><div class=\"visual\" data-v-3de4ef96><img class=\"tree-arm\" src=\"" + _imports_4 + "\" data-v-3de4ef96><img class=\"tree-arm\" src=\"" + _imports_4 + "\" data-v-3de4ef96><img class=\"tree-base\" src=\"" + _imports_5 + "\" data-v-3de4ef96></div><ul class=\"list-unstyled value-list\" data-v-3de4ef96><li data-v-3de4ef96>Each person sees a single, connected view that includes all the trees shared with them.</li><li data-v-3de4ef96>Works seamlessly even if the trees were created by different users using different programs.</li><li data-v-3de4ef96>Overlapping trees are consolidated for viewing.</li><li data-v-3de4ef96>The trees themselves are never &quot;merged&quot;.</li></ul></div></div></div>", 3)
const _hoisted_5 = { class: "value-row privacy-value" }
const _hoisted_6 = { class: "container-lg" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Personal privacy controls", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Each person can decide what to share about themselves, and who to share it with.", -1))
const _hoisted_9 = { class: "details" }
const _hoisted_10 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "shield",
  viewBox: "1944.17 850.17 512.67 514.67",
  preserveAspectRatio: "xMidYMid meet",
  width: "100%",
  height: "100%"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "person"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-unstyled value-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "When you share your tree with someone, they also get full control of their own profile."),
  /*#__PURE__*/_createElementVNode("li", null, "Changes they make to their profiles don't affect the file on your computer."),
  /*#__PURE__*/_createElementVNode("li", null, "Profiles are only visible to people in the same Group."),
  /*#__PURE__*/_createElementVNode("li", null, "Parents can control what information is shared in their children's profiles.")
], -1))
const _hoisted_13 = { class: "value-row easy-value" }
const _hoisted_14 = { class: "container-lg" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Direct upload", -1))
const _hoisted_16 = { class: "details" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-unstyled value-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "No export to GEDCOM or merging into a global tree."),
  /*#__PURE__*/_createElementVNode("li", null, "Photos and documents are uploaded automatically."),
  /*#__PURE__*/_createElementVNode("li", null, "You control which living people are included."),
  /*#__PURE__*/_createElementVNode("li", null, "Only one click to update your tree later, too.")
], -1))

import { computed, onMounted, onBeforeUnmount, ref } from 'vue'
import { workspaceTypeInfos } from '@/rd/ResearchDataModel'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import SyncDiagram from '@/sync/SyncDiagram.vue'
import AppSupportGrid from './AppSupportGrid.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePageValue',
  setup(__props) {

const privacyVisualRef = ref<HTMLElement>()
const shieldPathRef = ref<SVGPathElement>()

const supportedAppsRef = computed(() => workspaceTypeInfos.filter(t => (t.supportedOn.length || t.plannedOn.length) && !t.hidden))

const triggers: ScrollTrigger[] = []
let shieldPathLength = 0

onMounted(() => {
  shieldPathLength = shieldPathRef.value?.getTotalLength() ?? 0
  shieldPathRef.value!.style.strokeDasharray = String(shieldPathLength)
  shieldPathRef.value!.style.strokeDashoffset = String(shieldPathLength)

  const rows = gsap.utils.toArray<HTMLElement>('.value-row')
  rows.forEach(elem => addScrollTrigger(elem, (self) => {
      elem.style.setProperty('--reveal-p', String(self.progress))
  }))

  const visuals = gsap.utils.toArray<HTMLElement>('.value-row .details .visual')
  visuals.forEach(elem => addScrollTrigger(elem, (self) => {
      elem == privacyVisualRef.value
        ? updateShieldReveal(self.progress)
        : elem.style.setProperty('--reveal-p', String(self.progress))
  }))
})

function addScrollTrigger(elem: HTMLElement, onUpdate: (self: ScrollTrigger) => void) {
  const t = ScrollTrigger.create({
    trigger: elem,
    start: 'top 95%',
    end: 'top 65%',
    scrub: true,
    onUpdate
  })
  triggers.push(t)
}

function updateShieldReveal(p: number) {
  const start = 0.2
  const end = 1
  const t = Math.min(1, Math.max(0, (p - start) / (end - start)))
  shieldPathRef.value!.style.strokeDashoffset = String(shieldPathLength * (1 - t))
}

onBeforeUnmount(() => {
  triggers.forEach(t => t.kill())
  triggers.length = 0
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            ref_key: "privacyVisualRef",
            ref: privacyVisualRef,
            class: "visual"
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_10, [
              _createElementVNode("path", {
                ref_key: "shieldPathRef",
                ref: shieldPathRef,
                d: "M2200.5 868.5 2246.38 890.534C2292.58 910.017 2341.08 925.145 2391.36 935.403L2438.5 942.575 2438.5 1020.02C2438.5 1163.12 2351.23 1285.9 2226.86 1338.34L2200.5 1346.5 2174.14 1338.34C2049.77 1285.9 1962.5 1163.12 1962.5 1020.02L1962.5 942.575 2009.64 935.403C2059.92 925.145 2108.42 910.017 2154.62 890.534L2200.5 868.5Z",
                stroke: "#0070C0",
                "stroke-width": "36.6667",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-miterlimit": "10",
                fill: "none",
                "fill-rule": "evenodd",
                "stroke-dasharray": "10000",
                "stroke-dashoffset": "10000"
              }, null, 512)
            ])),
            _hoisted_11
          ], 512),
          _hoisted_12
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("h4", null, [
          _createTextVNode("Use our "),
          _createVNode(_component_router_link, { to: "/learn/sync" }, {
            default: _withCtx(() => [
              _createTextVNode("Sync app")
            ]),
            _: 1
          }),
          _createTextVNode(" to upload directly from your genealogy database.")
        ]),
        _createVNode(AppSupportGrid, { "icon-only": "" }),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(SyncDiagram, {
            small: "",
            motion: "",
            class: "visual"
          }),
          _hoisted_17
        ])
      ])
    ])
  ]))
}
}

})